<div class="lv-telefonnummer-inputs" [ngClass]="{'lv-error-state': errorState}">
  <mat-select name="laendervorwahl" #laendervorwahl="ngModel" [hideSingleSelectionIndicator]="true" class="lv-laendervorwahl"
              [disabled]="isDisabled"
              [ngModel]="telefonWertEingabe.laendervorwahl"
              (selectionChange)="setVorwahl($event)">
    <mat-select-trigger>
      <span>{{telefonWertEingabe.laendervorwahl}}</span>
    </mat-select-trigger>
    <ng-container *ngIf="loadedOptions$ | async as telefonNummern">
      <mat-option *ngFor="let telnumber of telefonNummern" [value]="telnumber.WertEingabe"
                  [disabled]="isDisabled">
        <div class="lv-vorwahl-option">
          <div> {{telnumber.WertAnzeige + ' (' + telnumber.WertEingabe + ')'}}</div>
        </div>
      </mat-option>
    </ng-container>
  </mat-select>
  <input matInput name="phonenumberInput" class="lv-phonenumber-input"
         [placeholder]="''" [disabled]="isDisabled"
         [required]="uiArtefakt.PflichtfeldJN" #phonenumberInput="ngModel"
         [ngModel]="telefonWertEingabe.nummer" (blur)="focusEvent.emit(true)"
         (ngModelChange)="setNummer($event)" [autocomplete]="autocomplete">
</div>
